import React from 'react';
import { Route } from 'react-router-dom';
import Hero from './Hero.js';
import Problem from './problem/Problem.js';
import Stats from './stats/Stats.js';

const Exercise = ({match, user}) => {

    return (
        <div>
            <Route component={Hero} />
            <Route exact path={match.path} component={Problem} />
            <Route path={`${match.path}/:id`} render={(props) => <Stats {...props} {...{user}} />} />
        </div>
    )
}

export default Exercise;
